module.exports = __webpack_public_path__ + "static/media/Weapon.0074b5dd.png";